import SportCodes from "../../../../../sports/common/sport-codes";
import PatResultType from "../../../../../sports/football/enums/pat-result-type";
import PatScoreType from "../../../../../sports/football/enums/pat-score-type";
import FootballState from "../../../../../sports/football/state/football-state";
import { getPatComplete } from "../../../../../sports/football/utils/context-utils";
import FootballStringifier from "../../../../stringifiers/football-stringifier";
import { FragmentSerializer } from "./FragmentSerializer";

export class PatFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.PatTry;
    }

    _getResult(play, gameContext) {
        const resFragment = play.fragments.find((f) => f.result || f.patCode);
        let resultCode = resFragment?.result || resFragment?.patCode;
        let resultPlayer;
        let resultScore;

        const { summaryContext } =
            FootballStringifier.generateSummary(play, gameContext) || {};
        const isPatComplete = getPatComplete(
            summaryContext,
            play.contextSnapshot,
            play
        );

        if (isPatComplete) {
            resultCode = PatResultType.GOOD.code;
        } else if (!resultCode) {
            resultCode = PatResultType.MISSED.code;
        }

        if (
            ![PatResultType.GOOD, PatResultType.MISSED].some(
                (t) => t.code === resultCode
            ) &&
            resFragment
        ) {
            resultPlayer = resFragment.getPlayers()?.[0];
            const modifiedSnapshot = {
                ...play.contextSnapshot,
                homeTeamHasPossession:
                    !play.contextSnapshot.homeTeamHasPossession
            };
            const defenseScored = getPatComplete(
                summaryContext,
                modifiedSnapshot,
                play
            );
            resultScore = defenseScored
                ? PatScoreType.SCORED.code
                : PatScoreType.NONE.code;
        }

        return { resultCode, resultPlayer, resultScore };
    }

    getRawFragment(play, serializationContext) {
        let value = "";
        const pat = play.fragments.find((f) => f.patType);
        const { sportId, gameContext } = serializationContext;
        if (pat) {
            const { resultCode, resultPlayer, resultScore } = this._getResult(
                play,
                gameContext
            );

            const uniforms = pat
                .getPlayers()
                .map((p) => this.resolveUniform(serializationContext, p));
            const values = [pat.patType, uniforms.join("/"), resultCode];
            if (resultPlayer && resultScore) {
                values.push(
                    this.resolveUniform(serializationContext, resultPlayer)
                );
                values.push(resultScore);
            }
            if (pat.isDropKick) {
                values.push("DK");
            }

            value = `PAT:${values.join()}`;

            if (sportId === SportCodes.FlagFootball) {
                const opponent = this.resolveOpponent(
                    serializationContext,
                    pat.getPlayers()[0]
                );
                const { fieldLength } = gameContext.gameConfig.general;
                const { driveStartingYardline } = gameContext.gameConfig.spots;
                const driveStartPosition = this.resolveFormattedFieldPosition(
                    serializationContext,
                    opponent === "H"
                        ? driveStartingYardline
                        : fieldLength - driveStartingYardline
                );
                value = `${value} SPOT:${opponent},${driveStartPosition},Y`;
            }
        }

        return value;
    }
}
